/**
 * NcFaireUnDevisComponent - Formulaire de demande de devis.
 * Gere : autocomplete produit, pre-remplissage URL params, validation, soumission.
 */
if (!customElements.get('nc-faire-un-devis-component')) {
  class NcFaireUnDevisComponent extends NCComponent {
    connectedCallback() {
      const form = this.$('#nc-devis-form');
      const submitBtn = this.$('#nc-devis-submit');
      const errorEl = this.$('#nc-devis-error');
      const banner = this.$('#nc-devis-product-banner');
      const bannerTxt = this.$('#nc-devis-product-banner-text');
      const prodInput = this.$('#nc-devis-produit');
      const prodHidden = this.$('#nc-devis-produit-val');
      const productWrap = this.$('#nc-devis-produit-wrap');
      const consentInput = this.$('#nc-devis-consent');
      const consentError = this.$('#nc-devis-consent-error');
      const formVariant = this.dataset.formVariant || 'quote';
      const bodyTitle = this.dataset.bodyTitle || (formVariant === 'price_alert' ? 'ALERTE DE PRIX' : 'DEMANDE DE DEVIS');
      const subjectPrefix = this.dataset.subjectPrefix || (formVariant === 'price_alert' ? 'Alerte de prix' : 'Demande de devis');
      const TF = (window.NCI18n && window.NCI18n.form) || {};
      const TQ = (window.NCI18n && window.NCI18n.quote) || {};
      const TA = (window.NCI18n && window.NCI18n.autocomplete) || {};
      const consentMessage = this.dataset.consentMessage || TQ.err_consent || 'Veuillez accepter d\'être contacté par mail.';
      const showQuantitySelector = formVariant !== 'price_alert';

      if (!form) return;

      this.#initAutocomplete(
        productWrap,
        prodInput,
        this.$('#nc-devis-produit-list'),
        prodHidden,
        showQuantitySelector
      );

      const params = new URLSearchParams(window.location.search);
      const produitParam = params.get('produit') || params.get('product') || '';
      const titreParam = params.get('titre') || params.get('title') || '';
      const detailsParam = params.get('details') || params.get('description') || '';
      const preselectProduct = this.dataset.preselectProduct || '';

      if (titreParam || produitParam || preselectProduct) {
        const displayName = titreParam
          ? decodeURIComponent(titreParam)
          : produitParam
            ? produitParam.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
            : preselectProduct;
        if (productWrap?.ncSetAutocompleteValues) productWrap.ncSetAutocompleteValues([displayName]);
        else prodHidden.value = displayName;
        if (banner) {
          banner.style.display = 'flex';
          bannerTxt.textContent = (TQ.product_selected_label || 'Devis pour : ') + displayName;
        }
      }

      if (detailsParam) {
        const detailsField = this.$('#nc-devis-details');
        if (detailsField) detailsField.value = decodeURIComponent(detailsParam);
      }

      this.$$('input, select, textarea').forEach(el => {
        el.addEventListener('input', () => {
          window.NCA11y?.clearFieldError(el, document.getElementById(el.id + '-error'));
        });
        el.addEventListener('change', () => {
          window.NCA11y?.clearFieldError(el, document.getElementById(el.id + '-error'));
        });
      });

      form.addEventListener('submit', e => {
        if (productWrap?.ncCommitAutocompleteValue) productWrap.ncCommitAutocompleteValue();

        const required = [...form.querySelectorAll('[required]')].filter(field => field.type !== 'checkbox');
        const validRequired = required.every(field => {
          const error = document.getElementById(field.id + '-error');
          return window.NCA11y?.validateField(field, error, this.#messagesFor(field)) ?? true;
        });

        const productValid = !!prodHidden.value.trim();
        if (!productValid) window.NCA11y?.setFieldError(prodInput, this.$('#nc-devis-produit-error'), TF.err_product || 'Veuillez sélectionner au moins un produit.');
        else window.NCA11y?.clearFieldError(prodInput, this.$('#nc-devis-produit-error'));

        const consentValid = !consentInput || consentInput.checked;
        if (!consentValid) window.NCA11y?.setFieldError(consentInput, consentError, consentMessage);
        else window.NCA11y?.clearFieldError(consentInput, consentError);

        if (!validRequired || !productValid || !consentValid) {
          e.preventDefault();
          form.querySelector('.is-error')?.focus();
          return;
        }

        submitBtn.disabled = true;
        submitBtn.querySelector('.spinner').style.display = 'block';
        if (errorEl) errorEl.hidden = true;

        const nom = this.$('#nc-devis-nom').value.trim();
        const prenom = this.$('#nc-devis-prenom').value.trim();
        const email = this.$('#nc-devis-email').value.trim();
        const tel = this.$('#nc-devis-tel').value.trim();
        const produit = (prodHidden.value || prodInput.value).trim();
        const quantite = this.$('#nc-devis-quantite').value.trim();
        const ville = this.$('[data-nc-city-combined]')?.value.trim() || '';
        const delai = this.$('#nc-devis-delai').value.trim();
        const details = this.$('#nc-devis-details')?.value.trim() || '';
        const consentLine = consentInput?.checked
          ? '\nConsentement email : accepte'
          : '';
        const titleSeparator = '='.repeat(Math.max(bodyTitle.length, 16));

        const bodyText =
          bodyTitle + '\n' + titleSeparator + '\n\n' +
          'Client : ' + prenom + ' ' + nom + '\n' +
          'Email : ' + email + '\n' +
          'Telephone : ' + tel + '\n\n' +
          'Produits : ' + produit + '\n' +
          (showQuantitySelector ? 'Quantite totale : ' + quantite + '\n' : '') +
          'Ville de livraison : ' + ville + '\n' +
          'Delai souhaite : ' + delai +
          consentLine +
          (details ? '\n\nDetails du projet :\n' + details : '') +
          (produitParam ? '\n\nLien produit : ' + window.location.origin + '/products/' + produitParam : '');

        const bodyHidden = this.$('#nc-devis-body');
        const sujetHidden = this.$('#nc-devis-sujet');
        if (bodyHidden) bodyHidden.value = bodyText;
        if (sujetHidden) sujetHidden.value = subjectPrefix + ' - ' + produit;
      });
    }

    #messagesFor(field) {
      const TF = (window.NCI18n && window.NCI18n.form) || {};
      const TQ = (window.NCI18n && window.NCI18n.quote) || {};
      const messages = {
        required: TF.err_required || 'Ce champ est obligatoire.',
        email: TF.err_email_format || 'Veuillez saisir une adresse email valide.',
        tel: TF.err_phone_format || 'Veuillez saisir un numéro de téléphone valide.'
      };
      if (field.id === 'nc-devis-nom') messages.required = TF.err_name || 'Veuillez renseigner votre nom.';
      if (field.id === 'nc-devis-prenom') messages.required = TF.err_firstname || 'Veuillez renseigner votre prénom.';
      if (field.id === 'nc-devis-ville') messages.required = TF.err_city || 'Veuillez renseigner la ville de livraison.';
      if (field.id === 'nc-devis-delai') messages.required = TQ.err_deadline || 'Veuillez choisir un délai.';
      return messages;
    }

    #initAutocomplete(wrap, input, list, hidden, showQuantitySelector = true) {
      if (!wrap || !input || !list || !hidden) return;

      const TA = (window.NCI18n && window.NCI18n.autocomplete) || {};

      let items = [];
      let origNames = [];
      const captureItems = () => {
        items = [...list.querySelectorAll('li[data-value]')];
        origNames = items.map(li => li.getAttribute('data-value'));
      };
      const ensureBuilt = () => {
        if (window.ncBuildAutocompleteList) window.ncBuildAutocompleteList(list);
        captureItems();
      };
      // Données chargées en différé (/?view=ac-data) : recapture si la liste est
      // construite de façon asynchrone après le 1er ensureBuilt.
      list.addEventListener('nc:autocomplete-built', captureItems);
      captureItems();
      const selectedBox = wrap.querySelector('[data-autocomplete-selected]');
      const quantityTotalField = wrap.closest('form')?.querySelector('#nc-devis-quantite');
      const selected = [];
      let activeIdx = -1;

      const escHtml = s => {
        const d = document.createElement('span');
        d.textContent = s;
        return d.innerHTML;
      };
      const normalize = value => value.trim().replace(/\s+/g, ' ');
      const clearActive = () => {
        items.forEach(li => {
          li.classList.remove('is-active');
          li.setAttribute('aria-selected', 'false');
        });
        input.setAttribute('aria-activedescendant', '');
      };
      const open = () => {
        ensureBuilt();
        filter(input.value);
        wrap.classList.add('is-open');
        input.setAttribute('aria-expanded', 'true');
      };
      const close = () => {
        wrap.classList.remove('is-open');
        input.setAttribute('aria-expanded', 'false');
        activeIdx = -1;
        clearActive();
      };

      const syncHidden = () => {
        hidden.value = selected.map(item => showQuantitySelector ? item.name + ' x ' + item.quantity : item.name).join(', ');
        if (quantityTotalField) {
          quantityTotalField.value = selected.reduce((total, item) => total + item.quantity, 0).toString();
        }
        items.forEach(li => {
          li.classList.toggle('is-selected', selected.some(item => item.name === li.getAttribute('data-value')));
        });
      };

      const renderSelected = () => {
        if (!selectedBox) return;
        selectedBox.innerHTML = '';
        selected.forEach(item => {
          const chip = document.createElement('span');
          chip.className = 'nc-autocomplete__chip';

          const label = document.createElement('span');
          label.className = 'nc-autocomplete__chip-label';
          label.textContent = item.name;

          let qty = null;
          if (showQuantitySelector) {
            qty = document.createElement('label');
            qty.className = 'nc-autocomplete__qty';

            const qtyInput = document.createElement('input');
            qtyInput.type = 'number';
            qtyInput.className = 'nc-autocomplete__qty-input';
            qtyInput.min = '1';
            qtyInput.max = '999';
            qtyInput.step = '1';
            qtyInput.inputMode = 'numeric';
            qtyInput.value = String(item.quantity);
            qtyInput.setAttribute('aria-label', (TA.qty_aria || 'Quantité pour %s').replace('%s', item.name));
            qtyInput.addEventListener('input', () => {
              const nextQuantity = parseInt(qtyInput.value, 10);
              item.quantity = Number.isFinite(nextQuantity) ? Math.min(Math.max(nextQuantity, 1), 999) : 1;
              syncHidden();
            });
            qtyInput.addEventListener('blur', () => {
              qtyInput.value = String(item.quantity);
            });
            qty.appendChild(qtyInput);
          }

          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'nc-autocomplete__chip-remove';
          remove.textContent = 'x';
          remove.setAttribute('aria-label', (TA.remove_aria || 'Retirer %s').replace('%s', item.name));
          remove.addEventListener('click', () => {
            const index = selected.findIndex(selectedItem => selectedItem.name === item.name);
            if (index >= 0) selected.splice(index, 1);
            syncHidden();
            renderSelected();
            filter(input.value);
            input.focus();
          });

          if (qty) chip.append(qty);
          chip.append(label, remove);
          selectedBox.appendChild(chip);
        });
      };

      const addValue = value => {
        value = normalize(value);
        if (!value) return;
        if (!selected.some(item => item.name === value)) selected.push({ name: value, quantity: 1 });
        input.value = '';
        window.NCA11y?.clearFieldError(input, document.getElementById(input.id + '-error'));
        syncHidden();
        renderSelected();
        filter('');
        close();
      };

      const commitInput = () => {
        if (input.value.trim()) addValue(input.value);
        else syncHidden();
      };

      wrap.ncCommitAutocompleteValue = commitInput;
      wrap.ncSetAutocompleteValues = values => {
        ensureBuilt();
        selected.splice(0, selected.length);
        values.map(normalize).filter(Boolean).forEach(value => {
          if (!selected.some(item => item.name === value)) selected.push({ name: value, quantity: 1 });
        });
        input.value = '';
        syncHidden();
        renderSelected();
        filter('');
        close();
      };

      const highlight = visible => {
        clearActive();
        if (!visible[activeIdx]) return;
        visible[activeIdx].classList.add('is-active');
        visible[activeIdx].setAttribute('aria-selected', 'true');
        input.setAttribute('aria-activedescendant', visible[activeIdx].id || '');
        visible[activeIdx].scrollIntoView({ block: 'nearest' });
      };

      const selectItem = li => addValue(li.getAttribute('data-value'));

      const filter = q => {
        q = q.toLowerCase().trim();
        list.querySelector('.nc-autocomplete__empty')?.remove();
        let hasVisible = false;

        items.forEach((li, i) => {
          const text = origNames[i].toLowerCase();
          const nameEl = li.querySelector('.nc-autocomplete__name');
          if (!nameEl) return;

          if (selected.some(item => item.name === origNames[i])) {
            li.classList.add('is-hidden');
          } else if (!q || text.includes(q)) {
            li.classList.remove('is-hidden');
            if (q) {
              const idx = text.indexOf(q);
              const orig = origNames[i];
              nameEl.innerHTML = escHtml(orig.slice(0, idx)) + '<mark>' + escHtml(orig.slice(idx, idx + q.length)) + '</mark>' + escHtml(orig.slice(idx + q.length));
            } else {
              nameEl.textContent = origNames[i];
            }
            hasVisible = true;
          } else {
            li.classList.add('is-hidden');
          }
        });

        if (!hasVisible && q) {
          const noResult = document.createElement('li');
          noResult.className = 'nc-autocomplete__empty';
          noResult.setAttribute('role', 'option');
          noResult.setAttribute('aria-disabled', 'true');
          noResult.textContent = (TA.no_result || 'Aucun produit trouvé pour « %s »').replace('%s', q);
          list.appendChild(noResult);
        }
        activeIdx = -1;
        clearActive();
        wrap.classList.add('is-open');
        input.setAttribute('aria-expanded', 'true');
      };

      input.addEventListener('focus', open);
      input.addEventListener('click', open);
      input.addEventListener('input', () => filter(input.value));
      input.addEventListener('keydown', e => {
        const visible = [...list.querySelectorAll('li[data-value]:not(.is-hidden)')];
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          activeIdx = Math.min(activeIdx + 1, visible.length - 1);
          highlight(visible);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          activeIdx = Math.max(activeIdx - 1, 0);
          highlight(visible);
        } else if (e.key === 'Enter' && activeIdx >= 0 && visible[activeIdx]) {
          e.preventDefault();
          selectItem(visible[activeIdx]);
        } else if (e.key === 'Enter' && input.value.trim()) {
          e.preventDefault();
          commitInput();
        } else if (e.key === 'Escape') {
          close();
        }
      });

      document.addEventListener('click', e => {
        if (!wrap.contains(e.target)) close();
      });
      list.addEventListener('click', e => {
        const li = e.target.closest('li[data-value]');
        if (li) selectItem(li);
      });

      if ('requestIdleCallback' in window) requestIdleCallback(ensureBuilt, { timeout: 2500 });
      else setTimeout(ensureBuilt, 1200);
    }
  }

  customElements.define('nc-faire-un-devis-component', NcFaireUnDevisComponent);
}
